module.exports = __webpack_public_path__ + "img/aceptado.6fbf577d.svg";